import React from 'react';
import { Route, IndexRoute } from 'react-router';
import Features from 'common/page/Features';
import Search from 'common/page/Search';
import Sid from 'webapp/page/Sid';
import Player from 'webapp/page/Player';
import Schedule from 'common/page/Schedule';
import ShortStopLive from 'webapp/page/ShortStopLive';
import Activate from 'webapp/page/Activate';
import Feedback from 'webapp/page/Feedback';
import Roadblock from 'webapp/page/Roadblock';
import UnsupportedPage from 'webapp/page/UnsupportedPage';
import Originals from 'common/page/Originals';
import CatalogPage from 'common/page/Catalog';
import SyndicatedPlayerPage from 'webapp/page/SyndicatedPlayerPage';
import SyndicatedPlayerExample from 'webapp/page/SyndicatedPlayerExample';
import AffiliatePageExample from 'webapp/page/AffiliatePageExample';
import AdobePassProxyLogin from 'common/page/AdobePassProxyLogin';
import AccountSelector from 'common/page/AccountSelector';
import ConnectedRootApplicationShell from 'common/RootApplicationShell';
import BasicShell from './subShell/BasicShell';
import PageShell from './subShell/PageShell';
import createLandingPage from 'common/createLandingPage';
import createCollection from 'common/createCollection';

function createRoutes() {
    return ([
        <Route path="/" component={ConnectedRootApplicationShell}>
            <Route component={BasicShell} key="route_0">
                <Route path="activate" component={Activate} />
                <Route path="subscribe" component={Activate} />
                <Route path="feedback" component={Feedback} />
                <Route path="roadblock" component={Roadblock} />
                <Route path="unsupported" component={UnsupportedPage} />
                <Route path="syndicated/player" component={SyndicatedPlayerPage} />
                <Route path="syndicated/player/example" component={SyndicatedPlayerExample} />
                <Route path="affiliate/example" component={AffiliatePageExample} />
                <Route path="mvpd/login" component={AdobePassProxyLogin} />
                <Route path="account-selector" component={AccountSelector} />
            </Route>
            <Route component={PageShell} key="route_1">
                <IndexRoute component={createLandingPage({ pageName: 'home' })} />
                <Route path="_/*" component={createLandingPage({ pageName: 'home' })} />
                <Route path="collections/:id(/g/:groupId)(/:junk)" component={createCollection()} />
                <Route path="originals" component={Originals} />
                <Route path="espnplus" component={createLandingPage({ pageName: 'espnplus' })} />
                <Route path="product/:id(/g/:groupId)(/:junk)" component={createCollection({ pageName: 'product' })} />
                <Route path="program/:id(/g/:groupId)(/:junk)" component={createCollection({ pageName: 'program' })} />
                <Route path="schedule" component={Schedule} />
                <Route path="player" component={Player} />
                <Route path="shortstoplive" component={ShortStopLive} />
                <Route path="search(/:searchTerm)" component={Search} />
                <Route path="sid(/:team)" component={Sid} />
                <Route path=":pageName/:id(/:junk)" component={CatalogPage} />
                <Route path=":pageName" component={Features} />
            </Route>
        </Route>
    ]);
}

export default createRoutes;



// WEBPACK FOOTER //
// ./app/webapp/routes.js